import { render, staticRenderFns } from "./AssignStatusButton.vue?vue&type=template&id=82152f8c&"
import script from "./AssignStatusButton.vue?vue&type=script&lang=js&"
export * from "./AssignStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports